import type { JSX } from 'react';

import { Button, Icon } from '@bookora/ui';

import { cancelArmedTour } from './runtime';
import { RUNTIME_COPY, armedWhere } from './runtime-copy';
import { useTourStore } from './tour-store';
import { TOURS } from './tours/registry';

/**
 * «راهنمای «پرونده بیمار» آماده است. پروندهٔ یک بیمار را باز کنید تا راهنما شروع شود.» [لغو]
 *
 * A context tour (a patient's file, an inline form, an import review) armed
 * from the hub, a tip or a deep link waits — for a working day, in this tab —
 * until its place opens. The toast that said so fades in seconds; this slim
 * notice keeps saying it, above the page, with a way to call it off. Page
 * tours are not shown here: they start as soon as their page is ready.
 */
export function ArmedNotice(): JSX.Element | null {
  const armed = useTourStore((s) => s.armed);
  const active = useTourStore((s) => s.active);
  if (!armed || active || armed.until <= Date.now()) return null;
  const tour = TOURS[armed.key];
  // Page tours start as soon as their page is ready; only a context tour waits.
  if (!tour.inlineHost && !tour.route?.context) return null;
  const where = armedWhere(tour);

  return (
    <div className="bk-armed-notice" role="status">
      <span className="bk-armed-notice__icon" aria-hidden="true">
        <Icon name="help" size={16} />
      </span>
      <p className="bk-armed-notice__text">
        {RUNTIME_COPY.armed.lead(tour.title)} {where}
      </p>
      <Button
        type="link"
        size="small"
        aria-label={RUNTIME_COPY.armed.cancelLabel}
        onClick={cancelArmedTour}
      >
        {RUNTIME_COPY.armed.cancel}
      </Button>
    </div>
  );
}
